import { ColumnDefMeta } from './types';

export function getAlignmentClass(align: ColumnDefMeta['align']) {
  switch (align) {
    case 'right':
      return 'eye:text-right';
    case 'center':
      return 'eye:text-center';
    default:
      return 'eye:text-left';
  }
}
